"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _heading = _interopRequireDefault(require("../heading"));
var _paragraph = _interopRequireDefault(require("../paragraph"));
var _parkingRatesTable = _interopRequireDefault(require("./parking-rates-table"));
var _helpers = require("./helpers");
var _indexModule = _interopRequireDefault(require("./index.module.scss"));
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
const formatParkingTime = timeStr => {
  const [hourStr, minStr] = timeStr.split(':');
  const rawHours = parseInt(hourStr, 10);
  const rawMins = parseInt(minStr, 10);

  // eslint-disable-next-line no-nested-ternary
  return "".concat(rawHours > 12 ? rawHours % 12 : rawHours > 0 ? rawHours : 12).concat(rawMins > 0 && rawMins < 60 ? ":".concat(rawMins) : '').concat(rawHours < 12 ? 'am' : 'pm');
};
const makeFreeTimeLine = (freeEntryTime, freeExitTime) => {
  const exitText = freeExitTime ? " ensuring you exit before\n  ".concat(formatParkingTime(freeExitTime), ".") : '.';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "We offer ", /*#__PURE__*/_react.default.createElement("strong", null, "free parking"), " with entry after", ' ', formatParkingTime(freeEntryTime), exitText);
};
const ParkingRates = _ref => {
  let {
    rateCards,
    freeEntryTime,
    freeExitTime,
    cinemaValidation,
    specialConditions,
    heading = 'Parking rates'
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, heading && /*#__PURE__*/_react.default.createElement(_heading.default, {
    type: "medium",
    className: _indexModule.default.heading
  }, heading), rateCards.map(card => /*#__PURE__*/_react.default.createElement(_react.Fragment, {
    key: card.days.join('-')
  }, /*#__PURE__*/_react.default.createElement(_heading.default, {
    type: "small",
    className: _indexModule.default.heading
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: _indexModule.default.capital
  }, card.days[0]), card.days.length > 1 ? /*#__PURE__*/_react.default.createElement(_react.Fragment, null, ' to ', /*#__PURE__*/_react.default.createElement("span", {
    className: _indexModule.default.capital
  }, card.days[card.days.length - 1])) : null), /*#__PURE__*/_react.default.createElement(_parkingRatesTable.default, {
    rates: card.rates
  }), /*#__PURE__*/_react.default.createElement(_paragraph.default, {
    type: "large",
    className: (0, _classnames.default)(_indexModule.default.maxRate, _indexModule.default.extraFees)
  }, "Maximum daily rate ".concat((0, _helpers.formatRate)(card.maximumRate))), /*#__PURE__*/_react.default.createElement(_paragraph.default, {
    type: "large",
    className: (0, _classnames.default)(_indexModule.default.overnightRate, _indexModule.default.extraFees)
  }, "Overnight fee ".concat((0, _helpers.formatRate)(card.overnightRate))))), freeEntryTime && /*#__PURE__*/_react.default.createElement(_paragraph.default, {
    type: "large"
  }, makeFreeTimeLine(freeEntryTime, freeExitTime)), specialConditions && /*#__PURE__*/_react.default.createElement(_paragraph.default, {
    type: "large"
  }, specialConditions), cinemaValidation && /*#__PURE__*/_react.default.createElement("div", {
    className: _indexModule.default.cinemaValidation
  }, cinemaValidation));
};
ParkingRates.propTypes = {
  rateCards: _propTypes.default.arrayOf(_propTypes.default.shape({
    days: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,
    rates: _propTypes.default.arrayOf(_propTypes.default.object.isRequired).isRequired,
    maximumRate: _propTypes.default.number.isRequired,
    overnightRate: _propTypes.default.number.isRequired
  })).isRequired,
  freeEntryTime: _propTypes.default.string,
  freeExitTime: _propTypes.default.string,
  cinemaValidation: _propTypes.default.element,
  specialConditions: _propTypes.default.string,
  heading: _propTypes.default.string
};
var _default = exports.default = ParkingRates;